"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dummyLogger = {
    log: function () {
    },
    error: function () {
    },
    warn: function () {
    },
    debug: function () {
    },
};
exports.default = dummyLogger;
//# sourceMappingURL=dummyLogger.js.map